/* eslint-disable no-unused-vars */
import firebase from "firebase/app";

export const state = {
  orders: [],
  order: {},
  orderLineItems: []
};

export const mutations = {
  SET_ORDERS(state, orders) {
    state.orders = orders;
  },
  SET_ORDER(state, order) {
    state.order = order;
  },
  SET_ORDER_LINE_ITEMS(state, lineItems) {
    state.orderLineItems = lineItems;
  }
};

export const actions = {
  async getOrders({ commit }, eventId) {
    var db = firebase.firestore();
    var orderRef = db
      .collection("events")
      .doc(eventId)
      .collection("userData")
      .doc("salesReport")
      .collection("orders")
      .orderBy("created", "desc");
    var docs = await orderRef.get();

    if (!docs.empty) {
      console.log("Got the orders", docs.docs.length);
      commit(
        "SET_ORDERS",
        docs.docs.map(doc => doc.data())
      );
    } else {
      commit("SET_ORDERS", []);
      console.log("Could not find any orders for this event.");
    }
  },
  setOrder({ commit }, order) {
    commit("SET_ORDER", order);
  },
  async fetchOrder({ commit }, { eventId, orderId }) {
    console.log("Fetching order:", orderId, "in event:", eventId);
    var db = firebase.firestore();
    try {
      var orderRef = db
        .collection("events")
        .doc(eventId)
        .collection("userData")
        .doc("salesReport")
        .collection("orders")
        .doc(orderId);
      var doc = await orderRef.get();

      if (doc.exists) {
        console.log("Got the order details");
        commit("SET_ORDER", doc.data());
      } else {
        console.log("Could not find order with ID:", orderId);
        commit("SET_ORDER", {});
      }
    } catch (error) {
      console.error("Error fetching order:", error);
      commit("SET_ORDER", {});
    }
  },
  async fetchOrderLineItems({ commit }, { eventId, orderId }) {
    console.log(
      "Fetching line items for order:",
      orderId,
      "in event:",
      eventId
    );
    var db = firebase.firestore();
    try {
      var lineItemsRef = db
        .collection("events")
        .doc(eventId)
        .collection("userData")
        .doc("salesReport")
        .collection("orders")
        .doc(orderId)
        .collection("lineItems");
      var docs = await lineItemsRef.get();

      if (!docs.empty) {
        console.log("Got the line items", docs.docs.length);
        commit(
          "SET_ORDER_LINE_ITEMS",
          docs.docs.map(doc => doc.data())
        );
      } else {
        commit("SET_ORDER_LINE_ITEMS", []);
        console.log("Could not find any line items for this order.");
      }
    } catch (error) {
      console.error("Error fetching order line items:", error);
      commit("SET_ORDER_LINE_ITEMS", []);
    }
  }
};

export const getters = {
  orders(state) {
    return state.orders;
  },
  order(state) {
    return state.order;
  },
  orderLineItems(state) {
    return state.orderLineItems;
  }
};
